import Select from './Select';
import './index.css';

export { SelectPicker } from './SelectPicker';

export type { SelectPickerConfig } from './interfaces';
export default Select;
